import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';

import { announcementKeys } from './api/query-keys';

export const useAnnouncementDismissal = () => {
    const { cobrainerApiFetcher } = useApplicationContext();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (announcementId: string) => {
            await cobrainerApiFetcher.post({
                pathname: `/announcements/${announcementId}/dismiss`,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: announcementKeys.history() });
            queryClient.invalidateQueries({ queryKey: announcementKeys.active() });
        },
    });
};
